(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nul-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqSection(sectionEl) {
      if (!sectionEl || sectionEl.dataset.faqInitialized === 'true') return;
      sectionEl.dataset.faqInitialized = 'true';

      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      sectionEl.querySelectorAll('.nul-faq__accordion').forEach(function (details) {
        var summary = details.querySelector('summary');
        var panel = details.querySelector('.nul-faq__accordion-content');
        if (!summary || !panel) return;

        summary.addEventListener('click', function (event) {
          event.preventDefault();
          if (details.open) {
            closePanel(details, panel);
          } else {
            openPanel(details, panel);
          }
        });
      });

      function setPanelHeight(panel, value) {
        panel.style.height = value;
      }

      function lockPanelOpenHeight(panel) {
        panel.style.transition = 'none';
        setPanelHeight(panel, 'auto');
        panel.offsetHeight;
        panel.style.transition = '';
      }

      function openPanel(details, panel) {
        if (prefersReducedMotion) {
          details.open = true;
          lockPanelOpenHeight(panel);
          return;
        }

        if (panel.dataset.animating === 'true') return;
        panel.dataset.animating = 'true';

        details.open = true;
        setPanelHeight(panel, '0');
        var targetHeight = panel.scrollHeight;

        requestAnimationFrame(function () {
          setPanelHeight(panel, targetHeight + 'px');
        });

        panel.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName !== 'height' || e.target !== panel) return;
          panel.removeEventListener('transitionend', onEnd);
          lockPanelOpenHeight(panel);
          delete panel.dataset.animating;
        });
      }

      function closePanel(details, panel) {
        if (prefersReducedMotion) {
          details.open = false;
          setPanelHeight(panel, '');
          return;
        }

        if (panel.dataset.animating === 'true') return;
        panel.dataset.animating = 'true';

        setPanelHeight(panel, panel.scrollHeight + 'px');

        requestAnimationFrame(function () {
          setPanelHeight(panel, '0');
        });

        panel.addEventListener('transitionend', function onEnd(e) {
          if (e.propertyName !== 'height' || e.target !== panel) return;
          panel.removeEventListener('transitionend', onEnd);
          details.open = false;
          setPanelHeight(panel, '');
          delete panel.dataset.animating;
        });
      }
    }

    function initAllFaqSections() {
      document.querySelectorAll('.nul-faq').forEach(initFaqSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFaqSections);
    } else {
      initAllFaqSections();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var faqSection = event.target.querySelector('.nul-faq');
      if (faqSection) initFaqSection(faqSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nul-product-comparison-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var emojiOnly = /^(?:\p{Extended_Pictographic}|\p{Emoji_Modifier}|\u200d|\ufe0f)+$/u;

    function markEmojiCells(root) {
      root.querySelectorAll('.nul-comparison__cell--value').forEach(function (cell) {
        cell.classList.remove('nul-comparison__cell--emoji');
        var text = cell.textContent.trim();
        if (text && emojiOnly.test(text)) {
          cell.classList.add('nul-comparison__cell--emoji');
        }
      });
    }

    function initComparisonSection(section) {
      markEmojiCells(section);
    }

    function initAllComparisonSections() {
      document.querySelectorAll('.nul-comparison').forEach(initComparisonSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllComparisonSections);
    } else {
      initAllComparisonSections();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.nul-comparison');
      if (section) initComparisonSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nul-related-products"] && !Shopify.designMode) return;
  try {
    
  function initNulRelatedProductsAjax(root) {
    if (!root || typeof theme === 'undefined' || typeof theme.AjaxProduct === 'undefined') return;
    if (theme.settings.cartType !== 'drawer') return;

    root.querySelectorAll('.nul-related-products__form').forEach(function (formEl) {
      if (formEl.dataset.ajaxInit === 'true') return;
      formEl.dataset.ajaxInit = 'true';
      new theme.AjaxProduct(formEl);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.nul-related-products').forEach(initNulRelatedProductsAjax);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.nul-related-products');
    if (section) initNulRelatedProductsAjax(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const row = document.querySelector('.product-single__related.product-row');
    const leftArrow = document.getElementById('scrollLeft');
    const rightArrow = document.getElementById('scrollRight');

    // Function to determine breakpoints
    const getSlideItemCount = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        // mobile devices
        return 1;
      } else if (width <= 1024) {
        // tablets
        return 3;
      } else {
        return 4; // Desktop
      }
    };

    // Function to calculate the scroll amount based on breakpoints
    const getScrollAmount = () => {
      const itemWidth = row.querySelector('.product-card-wrapper').offsetWidth;
      return getSlideItemCount() * itemWidth;
    };

    // Function to disable arrows when scrolled to the max
    function updateArrowVisibility() {
      const isFullyScrolledLeft = row.scrollLeft === 0;
      const isFullyScrolledRight = Math.ceil(row.scrollWidth - row.offsetWidth) === Math.ceil(row.scrollLeft);

      leftArrow.disabled = isFullyScrolledLeft;
      rightArrow.disabled = isFullyScrolledRight;

      const isAllVisible = row.scrollWidth <= row.offsetWidth;
      leftArrow.style.display = isAllVisible ? 'none' : 'inline-flex';
      rightArrow.style.display = isAllVisible ? 'none' : 'inline-flex';
    }

    leftArrow.addEventListener('click', () => {
      row.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    rightArrow.addEventListener('click', () => {
      row.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    row.addEventListener('scrollend', updateArrowVisibility);
    window.addEventListener('resize', updateArrowVisibility);

    updateArrowVisibility(); // Initial check
  });

  } catch(e) { console.error(e); }
})();
})();
